/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { QuestionConflictsControllerFindAllQueryResponse, QuestionConflictsControllerFindAllQueryParams, QuestionConflictsControllerFindAll401, QuestionConflictsControllerFindAll403 } from "../../models/checklistsController/QuestionConflictsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { questionConflictsControllerFindAll } from "../../clients/checklistsService/questionConflictsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const questionConflictsControllerFindAllQueryKey = (params: QuestionConflictsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-question-conflicts'
}, ...(params ? [params] : [])] as const;
export type QuestionConflictsControllerFindAllQueryKey = ReturnType<typeof questionConflictsControllerFindAllQueryKey>;
export function questionConflictsControllerFindAllQueryOptions(params?: QuestionConflictsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = questionConflictsControllerFindAllQueryKey(params);
  return queryOptions<QuestionConflictsControllerFindAllQueryResponse, ResponseErrorConfig<QuestionConflictsControllerFindAll401 | QuestionConflictsControllerFindAll403>, QuestionConflictsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return questionConflictsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List checklist question conflicts
 * {@link /api/v1/checklist-question-conflicts}
 */
export function useQuestionConflictsControllerFindAll<TData = QuestionConflictsControllerFindAllQueryResponse, TQueryData = QuestionConflictsControllerFindAllQueryResponse, TQueryKey extends QueryKey = QuestionConflictsControllerFindAllQueryKey>(params?: QuestionConflictsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<QuestionConflictsControllerFindAllQueryResponse, ResponseErrorConfig<QuestionConflictsControllerFindAll401 | QuestionConflictsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? questionConflictsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...questionConflictsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<QuestionConflictsControllerFindAll401 | QuestionConflictsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}